<template>
  <div class="bot-form-page">
    <form
      v-on:submit.prevent="addProduct"
      class="bot-add-form"
    >
      <select
        class="form-control bot-control"
        v-model="productId"
        required
      >
        <option
          value=""
          disabled
          selected
        >Продукт</option>
        <option
          v-for="option in products"
          v-bind:key="option.productId"
          :value="option.productId"
        >
          {{ option.product.code }}
        </option>
      </select>
      <select
        class="form-control bot-control"
        v-model="characterId"
        required
      >
        <option
          value=""
          disabled
          selected
        >Розмір</option>
        <option
          v-for="option in characters"
          v-bind:key="option.id"
          :value="option.characterId"
        >
          {{ option.character.name }}
        </option>
      </select>
      <button
        class="btn bot-action bot-action--secondary"
        type="submit"
      >
        {{ $filters.localize("button.add") }}
      </button>
    </form>

    <div class="bot-form-page__actions" v-if="entities.length > 0">
      <button
        type="button"
        class="btn btn-sm bot-action bot-action--primary"
        v-on:click="confirm"
      >Підтвердити резерв</button>
    </div>

    <div class="bot-table-card">
      <table class="table table-sm table-hover bot-table">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header of headers"
              v-bind:key="header.field"
            >
              {{ header.name }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of entities"
            v-bind:key="index"
          >
            <td class="text-center">
              <select
                :disabled="true"
                class="form-control bot-control"
                v-model="row.productId"
              >
                <option
                  v-for="option in remains"
                  v-bind:key="option.productId"
                  :value="option.productId"
                >
                  {{ option.product.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                :disabled="true"
                class="form-control bot-control"
                v-model="row.characterId"
              >
                <option
                  v-for="option in remains"
                  v-bind:key="option.characterId"
                  :value="option.characterId"
                >
                  {{ option.character.name }}
                </option>
              </select>
            </td>
            <td>
              <p>{{ row.quantity }}</p>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm bot-action bot-action--danger"
                v-on:click="removeProduct(index)"
              >X</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="entities.length === 0"
        class="bot-empty"
      >
        {{ $filters.localize("main.notdata") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reservation",
  computed: {
    characters: {
      get() {
        var remain = [...this.remains.filter(x => x.productId === this.entity.productId && x.quantity > 0)];
        return remain.sort((a, b) => a.character.name - b.character.name);
      }
    },
    products: {
      get() {
        var remain = [...this.remains.filter(x => x.quantity > 0)]
        return remain.filter((item, index, self) =>
          index === self.findIndex((t) => (
            t.productId === item.productId
          ))
        );
      }
    },
    characterId: {
      get() {
        return this.entity.characterId;
      },
      set(value) {
        this.entity.characterId = value;
        this.setMinPrice();
        this.setMaxQuantity();
      }
    },
    productId: {
      get() {
        return this.entity.productId;
      },
      set(value) {
        this.entity.productId = value;
        this.setMinPrice();
        this.setMaxQuantity();
      }
    },
    requestBody: {
      get() {
        return {
          products: JSON.parse(JSON.stringify(this.entities))
        };
      }
    }
  },
  data() {
    return {
      minPrice: 0,
      maxQuantity: 0,
      entity: {
        productId: "",
        characterId: "",
        quantity: 1,
        price: 0,
      },
      remains: [],
      entities: [],
      headers: [
        { name: this.$filters.localize("tableColumns.common.product") },
        { name: this.$filters.localize("main.size") },
        { name: this.$filters.localize("tableColumns.common.price") }
      ]
    }
  },
  methods: {
    confirm() {
      this.$http.post(window.location.origin + "/api/v1/order/set", this.requestBody)
        .then(response => {
          this.$toast.success("Номер резерву: " + response.data.data);
          this.entities = [];
          this.loadLookups();
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
          this.loadLookups();
        });
    },

    setMaxQuantity() {
      this.maxQuantity = this.remains.find(x => x.productId === this.entity.productId && x.characterId === this.entity.characterId)?.quantity ?? 0;
    },
    setMinPrice() {
      this.minPrice = this.remains.find(x => x.productId === this.entity.productId && x.characterId === this.entity.characterId)?.product?.wholeSalePrice ?? 0;
    },
    addProduct() {
      this.entities.push(this.entity);
      this.entity = {
        productId: "",
        characterId: "",
        quantity: 1,
        price: 0
      };
    },
    removeProduct(id) {
      this.entities = this.entities.filter((_, index) => index !== id);
    },
    loadLookups() {
      this.$store.dispatch('section', { table: "productremains" })
        .then((response) => {
          this.remains = response.data.data;
        });
    },
  },
  mounted() {
    this.$store.dispatch('section', { table: "contact" })
    this.loadLookups();
  }
}
</script>

<style scoped>
.bot-form-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bot-add-form,
.bot-form-page__actions,
.bot-table-card {
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 38, 65, 0.05);
}

.bot-add-form {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(150px, 0.7fr) auto;
  gap: 8px;
  padding: 10px;
}

.bot-form-page__actions {
  flex: 0 0 auto;
  padding: 10px;
}

.bot-control {
  min-height: 36px;
  border-color: #d9e2ec;
  border-radius: 8px;
  font-weight: 600;
}

.bot-action {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 0.74rem;
  font-weight: 800;
  white-space: nowrap;
}

.bot-action--primary {
  color: #0f7a3a;
  border-color: #86d99a;
  background: #f0fdf4;
}

.bot-action--secondary {
  color: #173b5d;
  border-color: #d9e2ec;
  background: #f7fafc;
}

.bot-action--danger {
  color: #b42318;
  border-color: #f0a8a0;
  background: #fff8f7;
}

.bot-table-card {
  position: relative;
  min-height: 0;
  flex: 1;
  overflow: auto;
  box-shadow: 0 14px 30px rgba(15, 38, 65, 0.08);
  -webkit-overflow-scrolling: touch;
}

.bot-table {
  min-width: 620px;
  margin-bottom: 0;
}

.bot-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 1px solid #dfe7f0;
  color: #526171;
  background: #f7fafc;
  font-size: 0.76rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.bot-table td {
  vertical-align: middle;
}

.bot-empty {
  padding: 24px;
  color: #7b8794;
  text-align: center;
  font-weight: 700;
}

@media (max-width: 767.98px) {
  .bot-form-page {
    gap: 8px;
  }

  .bot-add-form {
    grid-template-columns: 1fr;
    padding: 10px 12px;
  }

  .bot-action {
    width: 100%;
  }

  .bot-add-form .bot-control {
    font-size: 16px;
  }
}
</style>
